import { HttpClient } from '@angular/common/http';
import { Post } from '@app/shared/models/post';
import { environment } from '@env/environment';
import { isUndefined, omitBy } from 'lodash';
import { Observable } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { ApiClientConfig } from '../api-client.config';
import { PostArrayResponse, PostRequest, PostResponse } from './api.post.model';

export class PostApi {
  private apiUrl = environment.API_URL;

  POST = '/posts/posts';
  VERIFICATION = '/posts/verification';
  MODERATO = '/social-moderator';

  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  getPostsByUser(
    userId: string,
    pageNum: number,
    pageSize: number,
    isFriend: boolean,
    sortByDate: string
  ): Observable<Post[]> {
    return this.http
      .get<PostArrayResponse>(
        `${this.apiUrl}${this.POST}/user?pageNum=${pageNum}&pageSize=${pageSize}&userId=${userId}&isFriend=${isFriend}&sortByDate=${sortByDate}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map((res: PostArrayResponse) => {
          return res.data;
        }),
        catchError(err => {
          throw err.error;
        })
      );
  }

  updatePost(post: PostRequest, id: string): Observable<Post> {
    post = omitBy(post, isUndefined);
    return this.http.put<PostResponse>(`${this.apiUrl}${this.POST}/${id}`, post).pipe(
      timeout(this.config.responseTimeout),
      map((res: PostResponse) => {
        return res.data;
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }

  updateSharedPost(post: PostRequest, id: string): Observable<Post> {
    post = omitBy(post, isUndefined);
    return this.http.put<PostResponse>(`${this.apiUrl}${this.POST}/update-share/${id}`, post).pipe(
      timeout(this.config.responseTimeout),
      map((res: PostResponse) => {
        return res.data;
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }

  putModerateContentCensorship(body: any, isReviewList: boolean = false): Observable<any> {
    const approvalListPath = `${this.apiUrl}/social-moderator/moderate-contents/censorship`;
    const reviewListPath = `${this.apiUrl}/social-moderator/moderate-contents-history/censorship`;

    return this.http.put<any>(isReviewList ? reviewListPath : approvalListPath, body).pipe(
      timeout(this.config.responseTimeout),
      map((res: any) => {
        return res.success && res?.error?.code !== '4002';
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }

  putModerateAppealCensorship(body: any, isReviewList: boolean = false): Observable<any> {
    const approvalListPath = `${this.apiUrl}/social-moderator/appeal/censorship`;
    const reviewListPath = `${this.apiUrl}/social-moderator/appeal-history/censorship`;

    return this.http.put<any>(isReviewList ? reviewListPath : approvalListPath, body).pipe(
      timeout(this.config.responseTimeout),
      map((res: any) => {
        return res.success && res?.error?.code !== '4002';
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }
}
